<div [formGroup]="form">
    <!-- Checkboxes group start -->
    <div class="flex-row-generic checkbox-padding">
        <mat-checkbox id="{{ baseId }}-federally-qualified-health-center-checkbox" class="flex-item-three-columns"
            formControlName="federallyQualifiedHealthCenter" translate> Federally Qualified Health Center
        </mat-checkbox>
        <mat-checkbox id="{{ baseId }}-sliding-fee-carrier-checkbox" formControlName="slidingFeeCarrier"
        class="flex-item-three-columns" translate>
            Sliding Fee Carrier </mat-checkbox>
        <mat-checkbox id="{{ baseId }}-file-claims-checkbox" formControlName="fileClaims"
        class="flex-item-three-columns" translate> File Claims
        </mat-checkbox>
    </div>

    <div class="flex-row-generic">
        <mat-checkbox id="{{ baseId }}-auto-adjust-visits-checkbox" formControlName="autoAdjustVisits"
        class="flex-item-three-columns" translate> Auto
            Adjust Visits </mat-checkbox>
        <mat-checkbox id="{{ baseId }}-insured-always-same-as-patient-checkbox" class="flex-item-three-columns"
            formControlName="insuredAlwaysSameAsPatient" translate> Insured Always Same As Patient </mat-checkbox>
        <mat-checkbox id="{{ baseId }}-medicare-advantage-carrier-checkbox" formControlName="medicareAdvantageCarrier"
        class="flex-item-three-columns" translate> Medicare Advantage Carrier (File As Primary) </mat-checkbox>
    </div>
    <!-- Checkboxes group end -->



    <div class="flex-row-generic">
        <!-- CHC Settings Findcontrol start -->
        <div class="form-group flex-item-two-columns">
            <label for="{{ baseId }}-chc-settings-findcontrol">CHC Settings</label>
            <ap-findcontrol [baseId]="baseId" [form]="form" [apFormGroup]="form" [formGroupSubmitted]="isSubmitted"
                [required]="getFindControlValidation('ApprovalSettingUid')"
                [findControlId]="findControlIdService.ChcListApprovalSetting" [singleSelect]="true"
                [(selectedPks)]="selectedChcSettingsPks"
                id="{{ baseId }}-chc-setting-findcontrol" baseId="{{ baseId }}-chc-setting-findcontrol"
                controlName="chcSettingsUid" findControlDisplayName="Find Insurance Payer CHC Settings"
                (dirty)="chcSettingsUidControl.markAsDirty()">
            </ap-findcontrol>
        </div>
        <!-- CHC Settings Findcontrol Control end -->
    </div>

    <hr />

    <!-- Network start -->
    <h4 id="{{ baseId }}-address-subtitle" translate>Network</h4>
    <div class="flex-row-generic">
        <mat-checkbox id="{{ baseId }}-bypass-primary-filing-checkbox"
        formControlName="bypassPrimaryFiling" class="flex-item-three-columns" translate>
            Bypass Primary Filing on Medicare etc. </mat-checkbox>
    </div>
    <!-- Network end -->
</div>
